import React, { Component }  from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import ReactPlayer from "react-player";
import FixedHeader from '../../../components/FixedHeader';
import SocialMedia from '../../../components/SocialMedia';
import GlassCard from '../../../components/GlassCard';

import './styles.css';

export default class LabNinjasSmallSize extends Component {
  constructor(props) {
    super(props);
    this.state = {
      termsStatus: 'unknown'
    };
  }

  componentDidMount() {
    this.updateTermsStatus();
    window.addEventListener('termsStatusChange', this.updateTermsStatus);
  }

  componentWillUnmount() {
    window.removeEventListener('termsStatusChange', this.updateTermsStatus);
  }

  updateTermsStatus = () => {
    try {
      const storedValue = localStorage.getItem('termsStatus');
      const legacyValue = storedValue === null ? localStorage.getItem('termsAccepted') : null;
      const resolvedValue = storedValue ?? legacyValue;
      if (resolvedValue === 'accepted' || resolvedValue === 'true') {
        this.setState({ termsStatus: 'accepted' });
      } else if (resolvedValue === 'rejected') {
        this.setState({ termsStatus: 'rejected' });
      } else {
        this.setState({ termsStatus: 'unknown' });
      }
    } catch (error) {
      this.setState({ termsStatus: 'unknown' });
    }
  };

  render() {
      const { termsStatus } = this.state;
      const termsRejected = termsStatus === 'rejected';
      return(
        <Container fluid className="p-0" style={{ backgroundColor: 'var(--dashboard-bg)', minHeight: '100vh', color: 'var(--text)' }}>
          <FixedHeader/>
          <Container className="px-4 pb-4" style={{ paddingTop: '110px' }}>
            <Row className="justify-content-center mb-4">
              <GlassCard className="disclaimer">
              <h4 className='sr-only'>Lab Ninjas - Path to Revenge</h4>
                <img
                    alt="Lab Ninjas Logo"
                    src="/lab_ninjas_logo.png"
                    className="game-logo"
                  />
                  <br/>
                  <br/>
                  Lead an elite squad of ninjas on a quest for vengeance against their oppressors. Their village has been burned to the ground, their people scattered, and their honor tarnished. But they won’t surrender, <b>they fight back.</b>
                  <br/>
                  <br/>
                  Now, they need <b>YOU</b> to guide them on their path to justice. Train, strategize, and battle against relentless enemies in a thrilling ninja survival adventure!
                  <br/>
              </GlassCard>
            </Row>
            <div className='small-content'> 
              <Row className="justify-content-center mb-4">
                <GlassCard className="game-container-inner">
                          {termsRejected ? (
                            <div className="terms-blocked">Accept terms to view this video.</div>
                          ) : (
                            <ReactPlayer
                              src="https://youtu.be/IHy6SX2st8g"
                              style={{ width: '100%', height: 'auto', aspectRatio: '16/9' }}
                              controls
                            />
                          )}
                      <br/>
                      <b>Available now</b>
                      <a href="https://play.google.com/store/apps/details?id=com.forfunlab.labninjaspathtorevenge" target="_blank" rel="noopener noreferrer">
                        <img
                          alt="Get it on Google Play"
                          src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
                          className="google-play-button"
                          style={{ height: '90px' }}
                        />
                      </a>
                </GlassCard>
              </Row>
            </div>
          </Container>
          <SocialMedia isSmall={true} />
        </Container>
      );
  }
}
